import { Dialog } from 'element-ui';
import ResourceSvc from '@/services/resource.svc.js';
const svc = new ResourceSvc();
import FileListAnswer from '@/components/shared/answer-types/file-list/file-list.vue';

export default {
    name: 'ManageClubsConstitutionModal',
    components: {
        'file-list-answer': FileListAnswer,
        [Dialog.name]: Dialog,
    },
    props: {
        visible: { type: Boolean, default: false },
        clubId: { type: Number, default: null },
        clubYear: { type: Number, default: null },
    },
    data() {
        return {
            constitutionFiles: [],
            isUploading: false,
        };
    },
    computed: {
        localVisible: {
            get() { return this.visible; },
            set(val) { this.$emit('update:visible', val); },
        },
    },
    watch: {
        visible(val) {
            if (val && this.clubId) {
                this.loadExistingFile();
            } else if (!val) {
                this.constitutionFiles = [];
            }
        },
    },
    methods: {
        async loadExistingFile() {
            try {
                const response = await svc.getClubFileMetadata(this.clubId, 4, this.clubYear);
                if (response && response.body && response.body.isSuccess && response.body.outputData) {
                    this.constitutionFiles = [response.body.outputData];
                }
            } catch (e) {
                // no existing file, leave empty
            }
        },
        async save() {
            const file = this.constitutionFiles && this.constitutionFiles[0];
            if (!file || !file.itemContentString) {
                this.$showError('Please select a new PDF file to upload');
                return;
            }
            this.isUploading = true;
            try {
                const response = await svc.uploadClubConstitution(this.clubId, file, this.clubYear);
                if (response && response.body && response.body.isSuccess) {
                    this.$showSuccess();
                    this.$emit('uploaded');
                    this.close();
                } else {
                    this.$showError(response.body && response.body.message ? response.body.message : 'Failed to upload constitution');
                }
            } catch (e) {
                this.$showError('Failed to upload constitution');
            }
            this.isUploading = false;
        },
        previewConstitutionFile(fileId) {
            return svc.getClubFile(this.clubId, fileId, this.clubYear);
        },
        close() {
            this.constitutionFiles = [];
            this.$emit('update:visible', false);
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/clubs/manage-clubs/manage-clubs-constitution-modal/manage-clubs-constitution-modal.js